export default {
  newWindow: 'Ouvre une nouvelle fenêtre',
}
